<template>

  <b-card
    :title="printer.serial"
    img-src="https://picsum.photos/600/300/?image=724"
    img-top
    style="min-width: 15rem; max-width: 15rem;"
    class="mb-2"
  >
    <b-card-text>
      <!--Some quick example text to build on the card title and make up the bulk of the card's content.-->


      <p>{{printer.name}}</p>
      <p>
        <template v-if="printer.device.status !== 'OFFLINE'">
          <span class="mdi mdi-network-outline text-success"> Online</span>
        </template>
        <template v-else>
          <span class="mdi mdi-network-off-outline text-danger"> Offline</span>
        </template>
      </p>

      <div class="d-flex justify-content-between">
        <template v-for="c in printer.lasts.nodes">
          <div :key="`${printer.id}_${c.type}`">
            <span class="mdi" :class="{'mdi-water': c.value > 25, 'mdi-water-outline': c.value <= 25}" :style="`color: ${$options.colorMap[c.type]}`">{{c.value}} %</span>
          </div>
        </template>
      </div>

    </b-card-text>

    <b-button :to="`/main/admin/printers/view/${printer.id}`" variant="primary">Details</b-button>
  </b-card>
  
</template>

<script>

export default
{
    apollo:
    {
        $subscribe:
        {
            printer:
            {
                query: require('../graphql/printercard.sub.gql'),
                result({data: { printer }})
                {
                    this.printer = printer;
                },
                variables()
                {
                    return { id: this.id }
                }
            }
        }
    },
    data()
    {
        return {
            printer: { lasts: { nodes: [] }, device: {}  }
        }
    },
    props: ['id'],
    colorMap:
    {
        TONER_C: '#00FFFF',
        TONER_M: '#ff00ff',
        TONER_Y: '#FFD700',
        TONER_K: '#000000'
    }
}
</script>

<style>
</style>